export const getAirlines = (req)=>{
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        // body: JSON.stringify(req)
    };
    return fetch('/shared/api/airlinesList').then((response)=>response.json())
}